import React, {ReactNode} from 'react';
import {DialogProvider} from '@chekin/guestapp-ui-kit';
import {useFrame} from './frame';
import {environments} from 'configs';

interface Props {
  children: ReactNode;
}
export function SDKDialogProvider({children}: Props) {
  const {document: frameDocument} = useFrame();

  const container = environments.VITE_APP_IS_SDK ? frameDocument?.body || null : null;

  return <DialogProvider container={container}>{children}</DialogProvider>;
}
